/* eslint-disable func-call-spacing */
const Index = () => import('~pages/Lands/Index.vue')
const Lands = () => import('~pages/Lands/Lands.vue')

export default [
  {
    path: 'lands',
    component: Index,
    meta: {
      access: ['org.project.view']
    },
    children: [
      {
        name: 'lands',
        path: '/',
        component: Lands,
        meta: {
          access: ['org.project.view', 'project.view']
        }
      }
    ]
  }
]
